import React from 'react';
import useStyles from './useStyles';
import PropTypes from 'prop-types';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';

function CandidateDetails({ conversation }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {conversation.length > 1 ? (
        <React.Fragment>
          <h4>{`${conversation[0].candidate_name}, ${conversation[1].candidate_name}`}</h4>
          {conversation.length - 2 > 0 && (
            <div className={classes.remainingApplicants}>
              <GroupRoundedIcon color="primary" fontSize="small" />+{conversation.length - 2}
            </div>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <h4>{conversation[0].candidate_name}</h4>
          <span>{conversation[0].candidate_phone}</span>
        </React.Fragment>
      )}
    </div>
  );
}

CandidateDetails.propTypes = {
  conversation: PropTypes.array.isRequired
};

export default CandidateDetails;
